// Vertical mouse wheel scrolls horizontal chip rows (.scroll-x) on desktop.
export function installScrollRows() {
  window.addEventListener("wheel", (e) => {
    const row = e.target.closest?.(".scroll-x");
    if (!row || row.scrollWidth <= row.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    const max = row.scrollWidth - row.clientWidth;
    if ((e.deltaY < 0 && row.scrollLeft <= 0) || (e.deltaY > 0 && row.scrollLeft >= max - 1)) return;
    e.preventDefault();
    row.scrollBy({ left: e.deltaY, behavior: "auto" });
  }, { passive: false });
}
